module.exports=function(){
    $(".tab li").each(function(index) {
        $(this).click(function() {
            $(".show").removeClass("show");
            $(".hover").removeClass("hover");
            $(".box").eq(index).addClass("show");
            $(this).addClass("hover")
        });
    })
}
